<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-body class="mb-30" style="color:#3D515A;">
    <div class="register-number-outer-container">
      <div class="info-container" style="max-width:600px;">
        <div class="headings-container">
          <div class="heading">
            <adp-label *ngIf="isTablet" labelKey="RegisterTablet_QRCode_Heading"></adp-label>
            <adp-label *ngIf="isSmartwatch" labelKey="RegisterSmartwatch_QRCode_Heading"></adp-label>
          </div>

        </div>
        <div modal-body class="input-container" style="text-align: center;min-width: 100%;">
         <!-- Place QR code here -->

           <qrcode [qrdata]="value"
                 [width]="200"
                 [elementType]="elementType"
                 [errorCorrectionLevel]="correctionLevel"
                 alt="QR Code"
                 cssClass="bshadow">
           </qrcode>

            <div style="margin-top:35px;">
              <adp-label *ngIf="isTablet" style="color:#3D515A;font-weight:600;" labelKey="RegisterCellularDevice_QRCode_Tablet_Link_Alt_Text"></adp-label>
              <adp-label *ngIf="isSmartwatch" style="color:#3D515A;font-weight:600;" labelKey="RegisterCellularDevice_QRCode_Smartwatch_Link_Alt_Text"></adp-label>
              <br><button class='link' (click)='copyToClipboard()'><adp-label labelKey="RegisterCellularDevice_QRCode_Link_Text"></adp-label></button>
              <adp-label labelKey="RegisterCellularDevice_QRCode_Link_Alt_Subtext"></adp-label>
            </div>
        </div>
      </div>
    </div>
  </div>
  <div modal-footer class="row">
    <div class="col-12" style="margin-top:5px;margin-bottom:20px;">
      <button style="min-width:70%;" mat-flat-button color="accent" (click)="onCancelClicked()"><adp-label labelKey="Global_Button_Close"></adp-label></button>
    </div>
  </div>
</pgh-modal-window>
